// import { useMutation, useQueryClient } from "@tanstack/react-query";
// import { ChangeCustomerActive, UploadCustomerExcel } from "./api.js";
// import { CustomerList } from "./key.js";
// // export const useChangeCustomerActive = () => {
//     return useMutation({
//         mutationFn: ({ customerId, status }: any) =>
//             ChangeCustomerActive({ customerId, status }),
//     });
// };


import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
    ChangeCustomerActive,
    UploadCustomerExcel,
    UpdateCustomerNaturalByAdmin,
    UploadAverageNaturalCustomerExcel,
    UploadCustomerAverageVisitorExcel,
    UploadCustomerAverageExcel,
} from "./api.js";
import { CustomerList, CustomerInfo } from "./key.js";

export const useUploadCustomerAverageExcel = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ file, fileName }: { file: File; fileName: string }) =>
            UploadCustomerAverageExcel(file, fileName),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: CustomerList() });
        },
    });
};
import {
    ImportCustomerPaymentsExcel,
    DownloadListOfCustomerPayments,
} from "./api.js";


import {
    ClosingBankAccountsExcel, // ✅ اضافه شد
} from "./api.js";

// ============================================
// ✅ بستن حساب‌های مشتریان حقیقی از طریق اکسل
// ============================================
export const useClosingBankAccountsExcel = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ file, fileName }: { file: File; fileName: string }) =>
            ClosingBankAccountsExcel(file, fileName),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: CustomerList() });
        },
    });
};
// ============================================
// ✅ آپلود اکسل پرداخت مشتری‌ها
// ============================================
export const useImportCustomerPaymentsExcel = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ file, fileName }: { file: File; fileName: string }) =>
            ImportCustomerPaymentsExcel(file, fileName),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: CustomerList() });
        },
    });
};

// ============================================
// ✅ دانلود لیست مشتریان دارای مبلغ قابل پرداخت
// ============================================
export const useDownloadListOfCustomerPayments = () => {
    return useMutation({
        mutationFn: () => DownloadListOfCustomerPayments(),
    });
};
export const useUploadCustomerExcel = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ file, fileName }: { file: File; fileName: string }) =>
            UploadCustomerExcel(file, fileName),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: CustomerList() });
        },
    });
};
export const useUploadAverageNaturalCustomerExcel = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ file, fileName }: { file: File; fileName: string }) =>
            UploadAverageNaturalCustomerExcel(file, fileName),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: CustomerList() });
        },
    });
};


import {
    ChangeCustomerVisitor,
} from "./api.js";

// ============================================
// ✅ تغییر بازاریاب مشتری
// ============================================
export const useChangeCustomerVisitor = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ customerId, newVisitorCode }: any) =>
            ChangeCustomerVisitor(customerId, newVisitorCode),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({
                queryKey: CustomerInfo(variables.customerId),
            });
            queryClient.invalidateQueries({ queryKey: CustomerList() });
        },
    });
};
export const useUploadCustomerAverageVisitorExcel = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ file, fileName }: { file: File; fileName: string }) =>
            UploadCustomerAverageVisitorExcel(file, fileName),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: CustomerList() });
        },
    });
};
export const useChangeCustomerActive = () => {
    return useMutation({
        mutationFn: ({ customerId, status }: any) =>
            ChangeCustomerActive({ customerId, status }),
    });
};

// ============================================
// ✅ ویرایش اطلاعات مشتری حقیقی
// ============================================
export const useUpdateCustomerNaturalByAdmin = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, data }: { id: number; data: any }) => {
            return UpdateCustomerNaturalByAdmin(id, data);
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({
                queryKey: CustomerInfo(variables.id),
            });
            queryClient.invalidateQueries({ queryKey: CustomerList() });
        },
    });
};

import {

    SetDefaultStreetPlanForCustomer,
} from "./api.js";
import { CustomerPlans } from "./key.js";


// ============================================
// ✅ انتخاب طرح پیش‌فرض برای مشتری
// ============================================
export const useSetDefaultStreetPlanForCustomer = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ customerId, planId }: any) =>
            SetDefaultStreetPlanForCustomer(customerId, planId),
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({
                queryKey: CustomerPlans(variables.customerId),
            });
        },
    });
};

import { ChangePasswordByAdminApi } from "./api.js";
import { toastify } from "../../../../components/ui/Toasts/index.js";

export const useChangePasswordByAdmin = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: { customerId: number; password: string }) =>
            ChangePasswordByAdminApi(data),
        onSuccess: (res: any) => {
            if (res?.hasError) {
                toastify(
                    "error",
                    res?.message || "خطا در تغییر رمز عبور"
                );
                return;
            }
            toastify("success", "رمز عبور با موفقیت تغییر کرد");
            queryClient.invalidateQueries({ queryKey: ["GetCustomerInfo"] });
        },
        onError: (error: any) => {
            toastify(
                "error",
                error?.response?.data?.message || "خطا در تغییر رمز عبور"
            );
        },
    });
};

import { DownloadExcelFile } from "./api.js";
import { UploadCustomerExcelKey, ExcelFileList } from "./key.js";

// ============================================
// ✅ دانلود فایل اکسل آپلود شده
// ============================================
export const useDownloadExcelFile = () => {
  return useMutation({
    mutationFn: (uploadExcelFileId: number) =>
      DownloadExcelFile(uploadExcelFileId),
  });
};

// ============================================
// ✅ (اختیاری) برای invalidate کردن لیست بعد از آپلود موفق
// ============================================
export const useInvalidateExcelFileList = () => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: UploadCustomerExcelKey() });
    queryClient.invalidateQueries({ queryKey: ExcelFileList({}) });
    // یا بهتر:
    queryClient.invalidateQueries({ queryKey: ["ExcelFileList"] });
  };
};